export interface EmailValidationErrorProps {
  regex: RegExp;
}
export class EmailValidationError implements EmailValidationErrorProps {
  constructor(public regex: RegExp) {}
}
